import { render, staticRenderFns } from "./SuggestionDelete.vue?vue&type=template&id=45a0a354&scoped=true"
import script from "./SuggestionDelete.vue?vue&type=script&lang=js"
export * from "./SuggestionDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a0a354",
  null
  
)

export default component.exports